import { message } from "antd";
var common = {
  webRootPath:"/jfadmin/",
  phoneurl: window.location.host === "j.yunban.com" ? "https://service.yunban.com/" : "https://qa-service.iyunban.com",
  defaultTable : {
    columns : [],  //标题
    dataSource : [],  //数据
    pagination: {
      current : 1,
      total : 0,
      pageSize : 10,
      showQuickJumper : true,
      showSizeChanger : true,
      // pageSizeOptions : []
    },
    loading : false,  //loading状态
    bordered : false  //是否有边框
  },
  defaultFormItem : {
    labelCol: {
      xs: { span: 7 },
      sm: { span: 7 },
    },
    wrapperCol: {
      xs: { span: 10 },
      sm: { span: 10 },
    },
  },
  defaultFormItemBtn : {
    wrapperCol: {
      xs: { span: 10, offset:7 },
      sm: { span: 10, offset:7 },
    },
  },
  getDefaultFormItem : function(){
    return common.getObj(common.defaultFormItem);
  },
  getDefaultFormItemBtn : function(){
    return common.getObj(common.defaultFormItemBtn);
  },
  getEcardTable : function(table){
    const defaultTable = common.getDefaultTable();
    const columnsList = table.columnsList;

    let columnsShow = [];
    let columns = [];
    let mustList = [];
    common.eachObj(columnsList, function(index, dataItem){
      const dataIndex = dataItem.dataIndex;
      if(dataItem.must) mustList.push(dataIndex);
      if(dataItem.show) {
        columnsShow.push(dataIndex);
        columns.push(dataItem);
      }
    })
    table = Object.assign(defaultTable, table);
    table.columnsShow = columnsShow;
    table.columns = columns;
    table.mustList = mustList;
    table.scroll = common.getScroll(table);
    return table;
  },
  getScroll : function(table){
    const id = table.id;
    var scroll = 0;
    common.eachObj(table.columns, function(index, dataItem){
      if(dataItem.width){
        scroll = scroll + parseInt(dataItem.width, 10)
      } else {
        scroll = scroll + 300
      };
    });
    var a = document.getElementById(id);
    var width = a ? a.offsetWidth : 0;
    scroll = scroll > width ? scroll : width;
    return { x : scroll};
  },
  getDefaultTable : function(){
    const a = common.defaultTable;
    const b = common.getObj(a);
    return b;
  },
  request:function(postData, obj, callback, errback){ //（提交参数，当前组件，成功回调，失败回调）
    var _url = postData["_url"]
    if((postData["_url"].indexOf("/common") < 0) && (postData["_url"].indexOf("http") < 0)){
      _url = common.webRootPath + _url;
    }
    delete postData["_url"];

    var _method = "post";
    if(postData["_method"]){
      _method = postData["_method"];
      delete postData["_method"];
    }
    switch(_method){
      case "GET":case "DELETE":
        var a = 0;
        postData["t"] = postData["t"] = Math.floor(new Date().getTime()/3000);
        common.eachObj(postData, function(key, value){
          if(a === 0 && _url.indexOf("?") < 0){
            _url = _url + "?";
          } else {
            _url = _url + "&";
          }
          switch(typeof(value)){
            default:
              _url = _url + key + "=" + value;
              break;
          }
          a++;
        });
        fetch(_url,{
          credentials: 'include',//'include'
          method: _method,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }).then(response => response.json())
        .then(data => common.requestReturn(data, obj, callback, errback));
        break;
      default:
        postData = JSON.stringify(postData);
        fetch(_url,{
          credentials: 'include',//'include'
          method: _method,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
          body:postData,
        }).then(response => response.json())
        .then(data => common.requestReturn(data, obj, callback, errback));
        break;
    }
  },
  requestReturn:function(data, obj, callback, errback){
    if(data.status === "success"){
      if(callback){
        callback(obj, data);
      }
    } else {
      if(data.code === '100001'){
        window.location.href = "#/login";
      }
      if(data.status === 403){
        window.location.href = "login.html";
      }
      if(errback){
        errback(obj, data);
      } else {
         message.warning(data.message);
      }
    }
  },
  setUrlName:function(postData){
    var a = 0;
    var url = ""
    common.eachObj(postData, function(key, value){
      if(a === 0){
        url = url + "?" +  key + "=" + value;
      } else {
        url = url + "&" + key + "=" + value;
      }
      a++;
    });
    return url;
  },
  strToDateFormat:function(time, fmt) {
    if(!fmt) fmt = "yyyy年MM月dd日hh时mm分ss秒";
    if (!time || time === null || time === "") time = new Date();
    if(typeof(time) === "number" || typeof(time) === "string") if(time.toString().indexOf(" ") > -1) time = time.replace(" ", "T");
    var o = {
      "M+": time.getMonth() + 1, //月份
      "d+": time.getDate(), //日
      "h+": time.getHours(), //小时
      "m+": time.getMinutes(), //分
      "s+": time.getSeconds(), //秒
      "q+": Math.floor((time.getMonth() + 3) / 3), //季度
      "S": time.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)){
      fmt = fmt.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o){
      if (new RegExp("(" + k + ")").test(fmt)){
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  },
  strToDate:function(time) {
    if (time === null || time === "") {
      return '';
    } else {
      if(typeof(time) === "number" || typeof(time) === "string") if(time.toString().indexOf(" ") > -1) time = time.replace(" ", "T");
      var datetime = new Date(time);
      var year = datetime.getFullYear();
      var month = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
      var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      return year + "-" + month + "-" + date;
    }
  },
  strToTime:function(time) {
    function pad(num, n) {  
      var len = num.toString().length;  
      while(len < n) {  
          num = "0" + num;  
          len++;  
      }  
      return num;  
    }  
    if (time === null || time === "") {
      return '';
    } else {
      if(typeof(time) === "number" || typeof(time) === "string") if(time.toString().indexOf(" ") > -1) time = time.replace(" ", "T");
      var datetime = new Date(time);
      var hour = datetime.getHours();
      var minutes = datetime.getMinutes();
      var seconds = datetime.getSeconds();
      return pad(hour, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
    }
  },
  getObj : function(obj){
    return JSON.parse(JSON.stringify(obj))
  },
  eachObj:function(obj, call){
    if(!obj) return ;
    if(common.ifObjectEmpty(obj)) return;
    for(const key of Object.keys(obj)){
      if(call){
        call(key, obj[key]);
      } else {
        
      }
    }
  },
  ifNull:function(text){
    return text?text:"";
  },
  delNull:function(text){
    return text?text.replace(/text/g, ""):"";
  },
  ifObjectEmpty: function(obj){
    for (var key in obj) {
      return false;
    }
    return true;
  },
  toMonth : function(num){
    if(!num) num = 0;
    const now = new Date(new Date().setDate(1));
    var month = now.getMonth();
    const iniDate = common.strToDate(now.setMonth(month + num));
    return iniDate;
  },
  toDay : function(num, type){
    if(!num) num = 0;
    const now = new Date();
    const date = now.getDate();
    var iniDate = common.strToDate(now.setDate(date + num));
    if(type || type === 0){
      if(type === 0){
        iniDate = iniDate + " 00:00:00";
      }
      if(type === 1){
        iniDate = iniDate + " 23:59:59";
      }
    }
    return iniDate;
  },
  //form检验空格
  checkSpace: function (rule, value, callback){
    var reg = value && value.replace(/ /g, "");
    if (value && value.length > 0 && reg === "") {
      callback('请输入内容');
    } else {
      callback();
    }
  },
  validChinese : function (rule, value, callback){
    if (common.delNull(value) !== "") {
      callback();
    } else {
      callback('不能输入中文');
    }
  },
  validLength: function(a){
    return function (rule, value, callback){
      if(value && value.length > a){
        callback("请不要超过输入限制");
      } else {
        callback();
      }
    }
  },
  checkPhone : function(rule, value, callback){
    var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
    if (value && value.length !== 11 && !myreg.test(value)) {
      callback('请输入正确的手机号');
    } else {
      callback();
    }
  },
  checkIdCard : function(rule, value, callback){
    var myreg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/ ;
    if (value && !myreg.test(value)) {
      callback('请输入正确的身份证号');
    } else {
      callback();
    }
  },
  IsPC : function(){
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
  },
  getQueryString : function(name){
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if(r!=null)return  unescape(r[2]); return null;
  },
  getUrl : function(name){
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var url = window.location.hash.split("?")[1];
    if(!url) return null;
    var r = url.match(reg);
    if(r!=null)return  unescape(r[2]); return null;
  },
  lookUpTree : function(tree, subList,key, value){ //树， 子集键， 查找的键， 查找的值
    var a = [];
    if(!key || !value) return a;
    loop(tree);
    function loop(list){
      common.eachObj(list, function(index, dataItem){
        if(dataItem[subList]) loop(dataItem[subList]);
        if(dataItem[key] === value) {
          a.push(dataItem);
        }
      });
    }
    return a;
  },
  lookUpParent : function(tree, subList,key, value){ //树， 子集键， 查找的键， 查找的值
    var a = [];
    if(!key || !value) return a;
    var keys = [];
    loop(tree);
    function loop(list){
      common.eachObj(list, function(index, dataItem){
        if(dataItem[subList]) {
          keys.push(dataItem)
          loop(dataItem[subList]);
        }
        if(dataItem[key] === value) {
          keys.push(dataItem)
          a.push(keys);
          keys = [];
          return;
        }
        if(index === (list.length-1).toString()){
          keys.splice(keys.length-1,1)
        }
      });
    }
    return a;
  },
  setCookie : function(cname,cvalue,exdays){
    var d = new Date();
    d.setTime(d.getTime()+(exdays*24*60*60*1000));
    var expires = "expires="+d.toGMTString();
    document.cookie = cname+"="+cvalue+"; "+expires;
  },
  getCookie : function(cname){
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
      var c = ca[i].trim();
       if (c.indexOf(name) === 0) { return c.substring(name.length,c.length); }
     }
     return "";
   },
   showPage : function(pageType, pageData){
     this.setState({ pageType, pageData })
   },
   // 去两位小数
   toThNum : function(str) {
     var num = parseFloat(str).toFixed(3);//这里因为我需要两位小数所以做一个限制，你们看情况做小数位的限制
     var s = num.substring(0, (num.length-1));//只取小数位2位
     return s && s.toString().replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
       return $1 + ",";
     });
   },
   delSpace : function(str) {
     const value = str.replace(/\s+/g,"");
     return value;
   },
   shieldData : function(data, s, l){
     var shield = "";
     for(var i = 0; i < l ; i++){
       shield = shield + "*";
     }
     return data.replace(data.substr(s, l), shield);
   },
   shieldIdCard : function(data){
     return common.shieldData(data, 6, 8);
   },
   shieldPhone : function(data){
     return common.shieldData(data, 3, 4);
   },
   multipleArrow : function(value){
     return "select-multiple" + (value && value.length > 0 ? " hasselect" : " noselect");
   },
   validBrowser: {
     versions:function(){
       var u = window.navigator.userAgent;
       return {
         trident: u.indexOf('Trident') > -1, //IE内核
         presto: u.indexOf('Presto') > -1, //opera内核
         webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
         gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, //火狐内核
         mobile: !!u.match(/AppleWebKit.*Mobile.*/)||!!u.match(/AppleWebKit/), //是否为移动终端
         ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
         android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
         iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者安卓QQ浏览器
         iPad: u.indexOf('iPad') > -1, //是否为iPad
         webApp: u.indexOf('Safari') === -1 ,//是否为web应用程序，没有头部与底部
         weixin: u.indexOf('MicroMessenger') === -1 //是否为微信浏览器
       };
     }()
   }
 }
window.common = common;
export default common;



// WEBPACK FOOTER //
// ./src/assets/common.js